export default __webpack_public_path__ + "static/media/Machine Icon, Red.7b29c15d.png";